'use client';

import * as React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// viem
import { type Chain } from 'viem'
// wagmi
import { WagmiProvider, createConfig } from 'wagmi';
import {
  base,
  baseSepolia,
} from 'wagmi/chains';
import { http } from 'viem';
// rainbowkit
import {
  RainbowKitProvider,
  connectorsForWallets,
} from '@rainbow-me/rainbowkit';
import {
  injectedWallet,
  metaMaskWallet,
  walletConnectWallet,
  rainbowWallet,
  rabbyWallet,
  coinbaseWallet,
  phantomWallet,
  trustWallet,
  ledgerWallet,
  safeWallet,
  uniswapWallet,
} from '@rainbow-me/rainbowkit/wallets';


const walletList1 = [
  {
    groupName: 'Recommended',
    wallets: [
      metaMaskWallet,
      walletConnectWallet,
      rainbowWallet,
      rabbyWallet,
      phantomWallet,
      coinbaseWallet,
      trustWallet,
      injectedWallet,
      ledgerWallet,
      safeWallet,
      uniswapWallet,
    ],
  },
]

// Get chain ID from environment variable and convert to number
const chainId = process.env.NEXT_PUBLIC_CHAIN_ID
  ? Number(process.env.NEXT_PUBLIC_CHAIN_ID)
  : null;

// Set chains based on chain ID
const chains: readonly [Chain, ...Chain[]] = chainId === 84532
  ? [baseSepolia] as const
  : [base] as const;


const queryClient = new QueryClient();

export function Web3Providers({ children }: { children: React.ReactNode }) {
  const config = React.useMemo(() => {
    // WalletConnect touches browser-only storage; avoid initializing it during server/static render.
    const isBrowser = typeof window !== 'undefined';
    const connectors = isBrowser
      ? connectorsForWallets(walletList1, {
          appName: 'StickerChain',
          projectId: process.env.NEXT_PUBLIC_REOWN_PROJECT_ID || 'ABCDEFGHIJKLMNOP',
        })
      : [];

    return createConfig({
      connectors,
      chains,
      transports: {
        [base.id]: http(),
        [baseSepolia.id]: http(),
      },
      ssr: true,
    });
  }, []);

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>{children}</RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
